function RelaunchController(){
	this.className			= "RelaunchController";
	this.view				= false;
	this.glob				= ["/**"];
}
RelaunchController.inheritsFrom( StandardController );
RelaunchController.prototype.setup = function(onComplete){
	if(this.isSetup) return;

    this.isSetup = true;

	this.$body				= $('body');
    this.$popup = this.$body.find('.js-launch-popup');

    if(!this.$popup.length) return;

    //this.$body.css("position","fixed")

    this.$popupClose = this.$popup.find('.js-close');
    this.$popupClose.off("click").on("click", (e) => {

        e.preventDefault();
        e.stopPropagation();
        this.$popup.removeClass('show');
        //this.$body.css("position","")

    });

}
RelaunchController.prototype.swap = function(){
    if(!this.isSetup) this.setup();
    return true;
}